import { render, staticRenderFns } from "./homeSectionMain.vue?vue&type=template&id=cfa31dfe&scoped=true&"
import script from "./homeSectionMain.vue?vue&type=script&lang=js&"
export * from "./homeSectionMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa31dfe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
